import { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viChainSlash, viGear, viSpinnerThird } from "@sippy-platform/valkyrie";

import { Card, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function PbxItem({ pbx, account, accountDispatch, getPbxes }) {
  const auth = useSelector((state) => state.auth);

  // Direct API actions
  const [pending, setPending] = useState(false);

  function deletePbxFromAccount() {
    setPending(true);

    Promise.resolve(Api.deleteAccountFromPbx(account, pbx))
      .then(() => accountDispatch({ type: "removePbx", value: pbx }))
      .finally(() => setPending(false));
  }

  return (
    <Card variant="outlined">
      <List>
        <ListItem
          disablePadding
          sx={{ borderRadius: 0 }}
          secondaryAction={
            <>
              {getPbxes.length > 1 && !account.partner?.id && auth.accessLevel <= 1 && (
                <IconButton
                  onClick={() => deletePbxFromAccount(pbx)}
                  aria-label="Disconnect domain from account"
                  disabled={pending}
                >
                  <Valkyrie icon={pending ? viSpinnerThird : viChainSlash} spin={pending} />
                </IconButton>
              )}
              <IconButton
                component={NavLink}
                to={`/pbx/${pbx.context}/my-pbx`}
                aria-label="PBX settings"
                disabled={pending}
              >
                <Valkyrie icon={viGear} />
              </IconButton>
            </>
          }
        >
          <ListItemButton
            component={NavLink}
            to={`/pbx/${pbx.context}/dashboard`}
            disabled={pending}
            sx={{
              paddingRight:
                getPbxes.length > 1 && !account.partner?.id && auth.accessLevel <= 1 ? "92px !important" : 48,
            }}
          >
            <ListItemAvatar>
              <Avatar text={pbx.name} />
            </ListItemAvatar>
            <ListItemText primary={pbx.name} secondary={pbx.context} />
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

PbxItem.propTypes = {
  account: PropTypes.object,
  accountDispatch: PropTypes.func,
  pbx: PropTypes.object,
  getPbxes: PropTypes.array,
};

export default PbxItem;
